(function () {
    'use strict';

    angular
        .module('rms.common')
        .controller('EmployeeSelectionController', OnboardingEmployeeSelectionController);

    function OnboardingEmployeeSelectionController($scope, lodash, GenericModel, $q, ActionManager, $timeout) {
        const panelCtrl = getPanelCtrl($scope);
        const panelState = lodash.get(panelCtrl, 'panelState', null);
        const panelOption = lodash.get(panelState, 'structure.options', null);
        const panelModel = lodash.get(panelState, 'model', null);
        const panelForm = lodash.get(panelState, 'structure.component', null);


        loading(true);
        $q.all([
            loadDs('employeeListing', panelOption.employee_listing.datasource)
        ]).then(function (test) {
            $timeout(function () {
                loading(false);
            });
        });

        panelState.events = {
            select: select,
            isSelected: isSelected,
            getEmployeeItem: getEmployeeItem,
            removeSelected: removeSelected,
            addSelected:addSelected
        };

        $scope.$on('$destroy', function () {
            ActionManager('dm-close-dialog', {});
        });

        panelState.structure.refreshViewer = refresh;

        function refresh(){
            loading(true);
            $q.all([
                loadDs('employeeListing', panelOption.employee_listing.datasource)
            ]).then(function (test) {
                $timeout(function () {
                    loading(false);
                });
            });
        }

        $scope.colorCodeArray = [
            "#339E42",
            "#039BE5",
            "#EF6C00",
            "#A1887F",
            "#607D8B",
            "#039BE5",
            "#009688"
       ];

        function select(item) {
            const selected = isSelected(item);

            if (lodash.isEmpty(item) && selected) {
                return;
            }

            var template = 'tms/templates/onboarding/employee-selection-dialog';
            if (item.type == 'new_employee') {
                template = 'tms/templates/onboarding/new-employee-selection-dialog';
            }
            
            return $q.when(ActionManager('dm-open-dialog', {
                    controller: 'EmployeeSelectionDialogCtrl',
                    templateUrl: template,
                    dialog_options: {

                        employee: lodash.assign(item, {banner_options: panelOption.banner_options}),
                        hideModalHeader: true,
                        is_selected: selected,
                        options: panelOption.dialog_options
                    }
                }),

                function (res) {
                    res.modal.closed.then(function (dialogResult) {
                        if (dialogResult !== false) {
                            addSelected(item);
                        }
                    });
                }
            );
                
        }

        function isSelected(item) {
            const field_name = 'hid_selected_data';
            const existingValue = lodash.get(panelModel, field_name, []);
            const filtered = lodash.filter(existingValue, function (_item) {
                if(_item !== undefined) {
                    return _item.user_id === item.user_id;
                }
            });
            return filtered.length > 0;
        }

        function addSelected(provider) {
            const field_name = 'hid_selected_data';
            const existingValue = lodash.get(panelModel, field_name, []);
            const filtered = lodash.filter(existingValue, function (_item) {
                if(_item !== undefined) {
                    return _item.user_id === provider.user_id;
                }
            });
            if (filtered.length > 0) {
                return;
            }

            panelModel[field_name] = []; 

            panelModel[field_name] = {
                employee: provider,
                type: provider.type
            };
        }

        function removeSelected(e,provider) {
            e.stopPropagation();
            const field_name = 'hid_selected_data';
            const existingValue = lodash.get(panelModel, field_name, []);

            panelModel[field_name] = lodash.filter(existingValue, function (_item) {
                if(_item !== undefined) {
                    return _item.user_id !== provider.user_id;
                }
            });

            panelModel[field_name] = []; 
        }

        function getEmployeeItem(item) {
            if (lodash.has(panelState, 'employeeListing')) {
                return lodash.find(panelState.employeeListing, {select_id: item.user_id});
            }
            return null;
        }

        function loading(isloading) {
            var template = 'tms/templates/onboarding/loading';
            panelState.loading = isloading;
            if(isloading){
                $q.when(ActionManager('dm-open-dialog', {
                        controller: 'LoadingDialogCtrl',
                        templateUrl: template,
                        dialog_options: {
                            title: lodash.get(panelOption,'syncing_loader.title'),
                            message: lodash.get(panelOption,'syncing_loader.message'),
                            options: {
                                hideModalHeader: true,
                                modalSize: 'small',
                                modalClass: null
                            }
                        }
                    }));
            } else {
                ActionManager('dm-close-dialog', {});
            }   
        }

        function loadDs(name, _datasource) {
            panelState['error_data'] = null;
            lodash.set(panelOption, 'button_visibility.btn_save', false);
            const url = lodash.get(_datasource, 'url');
            const method = lodash.get(_datasource, 'method', 'get');
            const model = new GenericModel(url);
            const promise = model[method]().$promise.then(function (res) {
                if (res.success && res.status_code == 200) { //res
                    panelState[name] = res.rows; 

                    lodash.set(panelOption, 'button_visibility.btn_save', true);
                    panelState['success'] = true;
                    return res.rows;
                }
                else {
                    // console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    panelState['success'] = false;
                }
            }, function (res) {
                // console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                // console.warn(res); // eslint-disable-line no-console
                panelState['error_data'] = lodash.get(res, 'data', null);
                
                panelState['success'] = false;
            });
            return promise;
        }

        function getPanelCtrl(_scope) {
            const _vm = lodash.get(_scope, 'vm', null);
            if (!!_vm && _vm.constructor.name == 'asyncPanelCtrl') {
                return _vm;
            }
            if (lodash.has(_scope, '$parent')) {
                return getPanelCtrl(_scope.$parent);
            }
            return null;
        }
    }
})();